import React from 'react';
import PropTypes from 'prop-types';
import RpExpandableCheckboxOptions from 'components/commons/RpExpandableCheckboxOptions';
import useFilterStore from 'zustandStore/useFilterStore';

const SearchableCheckboxSelect = React.memo(function PropertyTypeFilter(props) {
    const filter = useFilterStore(state => state.filters[props.comparableType][props.attr]);
    const setFilters = useFilterStore(state => state.setFilters);

    const handleChange = (value) => {
        setFilters(props.comparableType, {
            [props.attr]: filter.includes(value)
                ? filter.filter(v => v !== value)
                : [...filter, value]
        });
    };

    const clearAll = () => {
        setFilters(props.comparableType, { [props.attr]: [] });
    };

    const selectAll = () => {
        setFilters(props.comparableType, { [props.attr]: props.options?.data?.map(o => o.value) });
    };

    return (
        <RpExpandableCheckboxOptions
            options={props?.options?.data}
            selected={filter}
            onChange={handleChange}
            title={props.label}
            clearAll={clearAll}
            selectAll={selectAll}
            columnSize={props.columnSize || 3}
            width="100%"
            onViewAll={props.onViewAll}
            maxRows={props.fullView ? undefined : 5}
            exitFullView={props.onSlidePanelClose}
            errorMessage={props?.options?.error}
            placeholder={props.placeholder}
            fullView={props.fullView}
        />
    );
});

SearchableCheckboxSelect.propTypes = {
    label: PropTypes.string,
    options: PropTypes.shape({
        data: PropTypes.arrayOf(
            PropTypes.shape({
                value: PropTypes.string.isRequired,
                label: PropTypes.string.isRequired,
            })
        ).isRequired,
        error: PropTypes.string,
    }),
    attr: PropTypes.string.isRequired,
    comparableType: PropTypes.string.isRequired,
    fullView: PropTypes.bool,
    columnSize: PropTypes.number,
    onViewAll: PropTypes.func,
};

export default SearchableCheckboxSelect;
